import React from 'react';
import { graphql } from 'gatsby';
import Accordion from '@atoms/styled-accordion';
import Container from '@atoms/Container';
import paddingDefault from '@utils/paddingDefault';
import { Helmet } from 'react-helmet';
import { colors } from '../primitives/colors';
import { StyledButtonAsLink } from '../primitives/styled-button';

const Faqs = ({ data }) => {
  const { settings, link } = data;
  const { dark_mode } = settings;

  return (
    <div css={[paddingDefault(), styles.background(!!dark_mode)]}>
      <Helmet>
        <script type="application/ld+json">
          {`
           {
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [{
                  "@type": "Question",
                  "name": "${data.headline}",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "${data.link.title}"
                  }
                }, ${data.questions[0].questions.map(node => {
            return `{

                "@type": "Question",
                "name": "${node.question}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "${node.answer.replace(/<a\b[^>]*>(.*?)<\/a>/i, '')}"

                }}`
          })}
                  ]
              }
            
          `}
        </script>
      </Helmet>
      <Container>
        <div css={styles.accordionWrap}>
          <Accordion faqs={data} onDark={!!dark_mode} />
          {!!link?.href && (
            <div css={styles.buttonWrap}>
              <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
};

const styles = {
  background: (onDark) => ({
    backgroundColor: onDark && colors.shadesBlack,
  }),
  buttonWrap: {
    display: "flex",
    marginTop: "2.5rem",
    "@media (min-width: 1024px)": {
      marginTop: "3rem"
    }
  },
  accordionWrap: {
    "@media (min-width: 1024px)": {
      paddingRight: "4rem",
      paddingLeft: "5rem",
      marginBottom: "0.5rem"
    }
  }
};

export const query = graphql`
  fragment FaqsData on CmsPageBuilderBlocks {
    faqs {
      settings {
        dark_mode
      }
      link {
        href
        title
      }
      headline
      byline
      questions {
        questions {
          question
          answer
        }
      }
    }
  }
`;

export default Faqs;
